module.exports = __webpack_public_path__ + "img/low_value.eeef2495.png";